export default {
  user: {},
  access_token: ''
}